import { Actions } from "@cirrus/fe-lib"
import { defaultTo, pick } from "ramda"

import { CurrentUser, Customer } from "../../entities/index.js"
import { CoreConfig } from "../../shared/config/index.js"

import { Bootstrap } from "./_params.js"

import { put, select, takeLatest } from "redux-saga/effects"

export const actions = Actions.of(Bootstrap.domain, ["requested", "started", "failed"])

export const effects = [
  takeLatest(actions.requested, function* () {
    yield put(Customer.actions.infoRequested())
    yield put(actions.started())
  }),

  takeLatest([Customer.actions.infoFetched], function* ({ payload }) {
    yield put(
      CoreConfig.actions.i18n.localization.availableLanguagesObtained(
        pick(["availableLanguages"], payload),
      ),
    )

    yield put(
      CoreConfig.actions.i18n.localization.defaultContentLocaleSwitch(
        pick(["defaultLanguage"], payload),
      ),
    )

    yield put(CurrentUser.actions.profileRequested())
    yield put(CurrentUser.actions.settingsRequested())
  }),

  takeLatest(CurrentUser.actions.settingsFetched, function* ({ payload }) {
    yield put(
      CoreConfig.actions.i18n.localization.localeSwitch({
        localeCode: defaultTo(payload.regs.lang, sessionStorage.getItem("loginLang")),
      }),
    )
  }),

  takeLatest(
    [CurrentUser.actions.settingsFetchFailed, CurrentUser.actions.settingsFetchCancelled],

    function* () {
      const { defaultContentLocale } = yield select(CoreConfig.state.i18n.localization.locales)

      yield put(
        CoreConfig.actions.i18n.localization.localeSwitch({
          localeCode: defaultTo(defaultContentLocale.code, sessionStorage.getItem("loginLang")),
        }),
      )
    },
  ),
]
